import * as React from 'react';
import CurrencyList from "@system/chain/currency-list";

const CurrencyOptions = (props) => {
    const getDefaultVal = () => {
        if (props.defaultValue)
            return props.defaultValue
        else
            return false
    }

    return (
        <>
            <select className="form-control form-control-xs" id="currency" name="targetCurrency" value={getDefaultVal()}
                onChange={async (e) => {
                    if (props.onChange) {
                        props.onChange(e.target.value);
                    }
                  
                }}>
                {Object.entries(CurrencyList.register).map((v) => (
                    <option value={v[1].slug} key={v[1].slug}>{v[1].slug + ' ('+v[1].Name+')'}</option>
                ))}
            </select>
        </>
    );
};

export default CurrencyOptions;